import React from 'react';
import './WorkWithUs.sass';
import Button from "../../components/button/Button";

const WORK_WITH_US_FORM_URL = 'https://forms.gle/vZdTc6QkDy89yJ3W8'
class WorkWithUsItem extends React.Component {
    render() {
        const { img, header, text, hiring, forwardedRef  } = this.props;

  return (
      <div ref={forwardedRef} className='work-item'>
        <img src={img} alt={header}/>
        <div>
          <h3 className='work-item__header'>{header}</h3>
          <p className='work-item__text'>{text}</p>
          {hiring && <p className='work-item__hiring'>We are hiring:</p>}
          {hiring &&
            <ul className='work-item__list'>
              {hiring.map((item, index) => <li key={index}>{item}</li>)}
            </ul>}
          <div onClick={() => window.open(WORK_WITH_US_FORM_URL)}>
            <Button filled>
              Become Booster
            </Button>
          </div>
        </div>
      </div>
  );
 }
}

export default WorkWithUsItem;


// WEBPACK FOOTER //
// ./containers/workWithUsPage/WorkWithUsItem.js